module.exports = __webpack_public_path__ + "img/logo-vrjmof2022_white.75040ff2.svg";